/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { certonaPageType } from '@/constants/certonaPageType';

export function getShelfPageType(
  taxonomyId: string | undefined,
  recordType: string | undefined,
  acesEnabled: boolean,
) {
  // If ACES is enabled, always return partsLandingEvent
  if (acesEnabled) {
    return certonaPageType.partsLandingEvent;
  }

  // Original logic for non-ACES flow
  const taxonomyParts = taxonomyId?.split('_');
  const firstPart = taxonomyParts?.[1];
  if (firstPart?.endsWith('-0')) {
    return certonaPageType.partsLandingEvent;
  } else if (firstPart?.endsWith('-10') || firstPart?.startsWith('cat')) {
    return certonaPageType.accessoriesCategoryLandingPage;
  }
}
